<template>
  <div>
    <div class="page-header page-header-small">
      <parallax
        class="page-header-image"
        style="background-image: url('img/img_1.png')"
      >
      </parallax>
      <div class="content-center">
        <div class="container">
          <h1 class="title" style="font-size: 3.0em; margin-bottom: 0px;padding-top: 40px">Welcome to the Rabbit Hole Tea Bar</h1>
          <h5>
            We are a Eugene local bubble tea shop.<br>
            We make authentic Taiwanese bubble tea.<br>
            We focus on serving good quality tea drinks to Eugene students,<br>
            and creating a comfortable place for everyone.
          </h5>
        </div>
      </div>
    </div>
<!--    <carousel-section></carousel-section>-->
    <div class="section section-about-us" style="background-color: #000000">
      <div class="container">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
<!--            <h2 class="title">Who we are?</h2>-->
<!--            <h5>-->
<!--              We are a Eugene local bubble tea shop.<br>-->
<!--              We make authentic Taiwanese bubble tea.<br>-->
<!--              We focus on serving good quality tea drinks to Eugene students,<br>-->
<!--              and creating a comfortable place for everyone.-->
<!--            </h5>-->
          </div>
        </div>
        <div class="separator separator-primary"></div>
        <div class="section-story-overview">
          <div class="row">
            <div class="col-md-12">
              <img style="margin-bottom: 50px" src="img/1.png" alt="1">
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <img style="margin-bottom: 50px" src="img/2.png" alt="2">
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <img style="margin-bottom: 50px" src="img/3.png" alt="3">
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <img style="margin-bottom: 50px" src="img/4.png" alt="Menu">
            </div>
          </div>
          <div class="row">
            <div class="col-md-8 ml-auto mr-auto text-center">
<!--              <h2 class="title">More about us</h2>-->
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div
                class="image-container image-left"
                style="background-image: url('img/c1.jpg');margin-bottom: 20px"
              ></div>
              <img style="margin-top: 50px" src="img/c3.JPG"/>
            </div>
            <div class="col-md-5">
              <!-- First image on the right side, above the article -->

              <img style="margin-top: 50px; margin-left: -10px" src="img/c5.JPG"/>
              <div
                  class="image-container image-right"
                  style="background-image: url('img/c2.jpg')"
              ></div>
            </div>
          </div>
          <div class="section section-contact-us text-center" style="background-color: #000000">
            <div style="color:white" class="container">
              <h5>
                240 E 17th Ave. Eugene, OR 97401. <br>
                550 Pearl St. Suite 155 Eugene, OR 97401. <br>
                <a
                    class="nav-link"
                    href="https://www.instagram.com/therabbitholetea/"
                    title="Follow us on Instagram"
                    data-placement="bottom"
                    style="color:#f5f5f5"
                >
                  <i class="fab fa-instagram">
                    Instagram
                  </i>

                </a>
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
<!--    <div class="section section-contact-us text-center">-->
<!--      <div class="container">-->
<!--        <h2 class="title">Where to find us?</h2>-->
<!--        <p>240 E 17th Ave. Eugene, OR 97401</p>-->
<!--        <p>550 Pearl St. Suite 155 Eugene, OR 97401</p>-->
<!--        <div class="row">-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>
<script>
import { Button, FormGroupInput } from '@/components';
import CarouselSection from "@/pages/components/CarouselSection";
export default {
  name: 'landing',
  bodyClass: 'landing-page',
  components: {
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput
  },
  data() {
    return {
      form: {
        firstName: '',
        email: '',
        message: ''
      }
    };
  }
};
</script>
<style></style>
